const COLUMN_INFO = {
    product: "Salt / composition name of the medicine",
    brand: "Brand name of the medicine",
    batch: `Batch name or batch number.
• If the same batch is entered again, quantity will be added to the existing batch
• For OTC products, batch is not required`,
    mfgDate: "Manufacturing date of the product. Past dates are disabled.",
    expDate: "Expiry date of the product. Must be after Manufacturing Date.",
    package: `Package type and package quantity.
Example:
• Strip → number of tablets per strip`,
    pkgQty: "Number of packages selected",
    totalUnitQty: "Package quantity × Package quantity selected",
    pkgRate: "Tax exclusive rate per package (manual entry)",
    discount: "Fixed price discount applied on this item",
    grossValue: "Total value after discount, before tax",
    tax: "Applicable tax percentage and calculated tax amount",
    pkgMrp: "MRP of one unit of package (tax inclusive, manual entry)",
    regularPrice: " Price of item one package exclusive tax",
    subtotal: "Final amount including tax",
};


const ADD_ITEMS = {
    searchMedicine: "Search for medicines by brand name or salt composition",
    searchOTC: "Search for OTC products like bandages, supplements, etc.",
    brandName: "Filled from search selection. Edit if needed.",
    saltName: "Filled from search selection. Edit if needed.",
    unitQuantity: "Number of units in one package",
    minimumAlertQuantity: "Alert when stock goes below this quantity",
    packagingType: "This describes how the medicine is packed and sold. Example:Paracetamol tablets packed in a strip of 10 tablets",
    productForm: "This describes the physical or pharmaceutical form of the medicine itself. Example:Paracetamol Tablet → Product form = Tablet",
    tax: "Tax (GST, VAT, etc.) percentage applicable on this item",
}
const PURCHASE_ITEM_SEARCH = {
    guideTitle: "How item search works on this page",
    guideBody: "This page uses two separate lists while you search. The dropdown above shows items already in your pharmacy inventory. The table below shows matching items from the master database that are not in your inventory yet.",
    itemType: "Choose Medicine or OTC to filter both the inventory dropdown and the master database table.",
    selectItems: "Pharmacy inventory — select an item here to add it directly to this purchase.",
    selectItemsTooltip: "Shows medicines/OTC already added to your pharmacy inventory (pharma/masterItem).",
    databaseSection: "Master database — items below are not in your pharmacy inventory yet. Click + to add them to inventory and this purchase in one step.",
    databaseEmpty: "No matching items found in the master database for this search.",
    databaseLoading: "Searching master database...",
};
export { COLUMN_INFO, ADD_ITEMS, PURCHASE_ITEM_SEARCH };